//export const backend_url = "http://192.168.1.51:3004" //Production
export const backend_url = "http://covid.geoint.mx/apidev" //Production
//export const backend_url = "http://localhost:3004" //local
